import { render, staticRenderFns } from "./RefundProductCollapsableItem.vue?vue&type=template&id=4b4d97a2&"
import script from "./RefundProductCollapsableItem.vue?vue&type=script&lang=js&"
export * from "./RefundProductCollapsableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports